(function(window, nullPipControllerFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.nullPipController = nullPipControllerFactory();
})(this, function() {
   'use strict';

   /**
    * @memberof TSC
    * @class nullPipController
    * @classdesc Null controller when PIP feature is not available
    */
   var noop = function() {}; // eslint-disable-line

   return Object.defineProperties({
      enter: noop,
      exit: noop,
      bindChangeEvent: noop,
      unbindChangeEvent: noop
   }, {
      inPip: {
         get: function() {
            return false;
         }
      },
      isSupported: {
         get: function() {
            return false;
         }
      }
   });
});
